import "core-js/modules/es.array.push.js";
import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.find.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/esnext.iterator.map.js";
import "core-js/modules/esnext.iterator.some.js";
import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue";
import _imports_0 from './images/money.png';
const _hoisted_1 = {
  key: 0,
  class: "html-content p-4"
};
const _hoisted_2 = {
  key: 1,
  class: "key-word mt-3 p-4"
};
const _hoisted_3 = {
  class: "flex justify-end mt-2 footer-box"
};
const _hoisted_4 = {
  class: "right-box flex items-center"
};
const _hoisted_5 = {
  class: "pb-1"
};
const _hoisted_6 = {
  class: "text-[#4E5969] flex items-center"
};
const _hoisted_7 = {
  class: "text-[#4E5969] flex items-center"
};
const _hoisted_8 = {
  class: "text-[#4E5969] flex items-center"
};
import { marked } from 'marked';
import { debounce, cloneDeep } from 'lodash-es';
import { useRouter } from 'vue-router';
import { ElMessage, ElMessageBox } from 'element-plus';
import { ref, onMounted, onUnmounted, computed, watch, inject, toRaw } from 'vue';
import { assessCreateSearchTask, assessQuickCreate, assessNodeTaskRestart, assessUpdateMsgContent } from '@views/main/api';
import { getTextNodes } from '@utils/window-helpers';
import useAppStore from '@views/app.store';
import useMainStore, { storeToRefs } from '@views/main/main.store';
import { domesticCategories, foreignCategories } from '@views/main/config';
import initIncrementalUpdate from '../mixins/incrementalUpdate.mixin';
import FoldBox from '../../FoldBox.vue';
import ContentBlock from '../components/ContentBlock.vue';
import KeyWord from './KeyWord.vue';
import SourceBlock from '../components/SourceBlock.vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'CorporateInformation',
  props: {
    item: {},
    content: {}
  },
  setup(__props) {
    const props = __props;
    const router = useRouter();
    const appStore = useAppStore();
    const mainStore = useMainStore();
    const {
      incrementalMessageList
    } = storeToRefs(mainStore);
    const FoldBoxRef = ref();
    const contentRef = ref(); // 内容区域ref
    const info = ref({});
    const keywordList = ref([]);
    const loading = ref(false);
    const animateEnd = ref(true);
    const keyWordArr = ref([]);
    const showContent = computed(() => {
      return info.value.content || '';
    });
    const showLinks = computed(() => {
      return info.value.links || [];
    });
    const disabled = computed(() => {
      return props.item.id !== mainStore.lastMsgId;
    });
    const showTitle = computed(() => {
      if (info.value.executeStatus === 3) {
        return `任务3：已完成用户常见问题列表生成并生成报告，本次任务消耗${appStore.getRight('SUMMARY')}点权益点`;
      }
      if (info.value.executeStatus === 2) {
        return `任务3：本次任务任务执行失败请点击重新生成`;
      }
      return '任务3：正在基于公司信息生成用户经常咨询问题列表';
    });
    function getRightNum(type) {
      const innerNum = appStore.getRight('gen_company_info', 'inner');
      const outerNum = appStore.getRight('gen_company_info', 'outer');
      if (type === 1) return innerNum + outerNum;
      if (type === 2) return innerNum;
      if (type === 3) return outerNum;
      return appStore.getRight('gen_company_info');
    }
    const createTask = async () => {
      await ElMessageBox.confirm('是否针对当前的信息和关键词生成网站分析报告操作？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      });
      try {
        loading.value = true;
        mainStore.loadNextMsg(props.item);
        await assessCreateSearchTask({
          keywords: keyWordArr.value,
          sessionId: mainStore.msgParams.sessionId
        });
        appStore.getAssessResidualEquityNum();
      } catch (error) {
        console.log(error);
      } finally {
        loading.value = false;
      }
    };
    const stopScrollLoop = inject('stopScrollLoop');
    // 处理增量数据
    const {
      handleIncrementalMessage
    } = initIncrementalUpdate(async message => {
      props.item.newLoad = false;
      if (props.item.id === message.id) {
        const incrementalData = message.incrementalData;
        info.value.content = incrementalData.content;
        animateEnd.value = false;
        FoldBoxRef.value?.setIsFold(true);
        appStore.getAssessResidualEquityNum();
        setTimeout(stopScrollLoop, 1000);
      }
    });
    const getKeywordsByEle = (ele, list, allLabels, depth = 1) => {
      if (!ele || depth > 4) return;
      // 1. 当前元素内部找 ul/ol
      let ulEle = ele.querySelector('ul') || ele.querySelector('ol');
      // 2. 向后找兄弟，遇到包含其他板块标题文本的元素则停止
      if (!ulEle) {
        let sibling = ele.nextElementSibling;
        while (sibling) {
          const tag = sibling.tagName;
          if (tag === 'UL' || tag === 'OL') {
            ulEle = sibling;
            break;
          }
          // 如果兄弟元素的文本包含其他分类标题，说明进入下一板块，终止
          const siblingText = sibling.textContent || '';
          if (allLabels.some(label => siblingText.includes(label))) break;
          sibling = sibling.nextElementSibling;
        }
      }
      if (ulEle) {
        list.push(...Array.from(ulEle.children).map(x => x.textContent?.trim() || ''));
      } else {
        getKeywordsByEle(ele.parentElement, list, allLabels, depth + 1);
      }
    };
    // 增加new Set处理 保证关键词不重复
    const setKeywordList = list => {
      list.forEach(item => {
        // eslint-disable-next-line no-param-reassign
        item.list = [...new Set(item.list)];
      });
      keywordList.value = list;
    };
    const extractKeyword = async text => {
      if (info.value?.messageContent?.keywordList) {
        setKeywordList(info.value.messageContent.keywordList);
        return;
      }
      const htmlText = await marked(text);
      const parser = new DOMParser();
      const doc = parser.parseFromString(htmlText, 'text/html');
      const textNodeArr = getTextNodes(doc);
      // 使用数组统一管理关键词分类
      const keywordCategories = cloneDeep(appStore.geoMode === 'inner' ? domesticCategories : foreignCategories);
      // 提取所有分类标题用于边界判断
      const allLabels = keywordCategories.map(c => c.label);
      // 优化循环逻辑
      textNodeArr.forEach(ele => {
        const category = keywordCategories.find(c => ele.textContent?.includes(c.label));
        if (category && !category.list.length) {
          getKeywordsByEle(ele.parentElement, category.list, allLabels);
        }
      });
      // 合并关键词列表
      setKeywordList(keywordCategories);
    };
    watch(showContent, newVal => {
      if (newVal) {
        extractKeyword(newVal);
      }
    }, {
      immediate: true
    });
    const handleAnimateEnd = () => {
      animateEnd.value = true;
      info.value.executeStatus = 3;
      mainStore.loadNextMsg(props.item);
    };
    // 快捷创建关键词
    const quickCreation = async () => {
      let arr = keyWordArr.value;
      if (!arr.length) {
        ElMessage.warning('请先选择关键词');
        return;
      }
      try {
        if (arr.length > 10) {
          await ElMessageBox.confirm('最多只能创建10个关键词,\n是否自动使用前10个关键词？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          });
          arr = arr.slice(0, 10);
        }
        const {
          sessionId
        } = mainStore.msgParams;
        const {
          data
        } = await assessQuickCreate({
          sessionId
        });
        sessionStorage.setItem(sessionId, JSON.stringify({
          keywords: arr,
          websiteInfo: data.websiteInfo,
          selectionModel: data.selectionModel
        }));
        window.open(`/form?type=1&id=${mainStore.msgParams.sessionId}`);
      } catch (e) {
        console.log(e);
      }
    };
    const openSideEdit = inject('openSideEdit');
    const handleEditView = () => {
      openSideEdit({
        type: 'edit_report_info',
        typeQuery: {
          disabled: disabled.value,
          quickCreation,
          keyWordArr: toRaw(keyWordArr.value)
        },
        // 这里的是整体对象传入的，借助浅复制的原理对内容进行同步更改
        contentData: {
          ...toRaw(info.value),
          knowledgeDetails: toRaw(keywordList.value)
        },
        title: showTitle.value,
        callBack: createTask
      });
    };
    const handleRestart = async () => {
      try {
        await assessNodeTaskRestart({
          sessionId: mainStore.msgParams.sessionId,
          taskNode: 205
        });
        info.value.executeStatus = 1;
      } catch (error) {
        console.log(error);
      }
    };
    // 编辑更新接口
    const debounceChangeKeyword = debounce((val, idObj) => {
      assessUpdateMsgContent({
        sessionId: idObj.sessionId,
        messageId: idObj.id,
        messageContent: {
          keywordList: val,
          keyWordArr: keyWordArr.value
        }
      });
    }, 1500);
    const handleChangeKeyword = val => {
      const idObj = {
        sessionId: mainStore.msgParams.sessionId,
        id: props.item.id
      };
      debounceChangeKeyword(val, idObj);
    };
    // 0 快捷生成企业知识库 1 中/英文企业知识库 2 中文企业知识库 3 英文企业知识库
    const handleCreateInfo = type => {
      // 如果同时拥有内贸geo和海外geo的权益则需要用户选择
      if (type === 0 && appStore.getRightsByIds([605, 628])) return;
      ElMessageBox.confirm(`是否根据当前报告内容生成企业知识库，预计消耗${getRightNum(type)}点权益`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let queryType = type;
        if (type === 0) {
          queryType = appStore.geoMode === 'inner' ? 2 : 3;
        }
        router.push({
          name: 'analytical-companyGen',
          query: {
            id: mainStore.msgParams.sessionId,
            type: queryType
          }
        });
      });
    };
    onUnmounted(() => {
      mainStore.componentFunMap.delete(props.item.id);
    });
    onMounted(() => {
      if (props.item.id) {
        mainStore.componentFunMap.set(props.item.id, handleIncrementalMessage);
      }
      try {
        if (props.content) info.value = props.content;
        // 处理增量数据
        if (props.item.incrementalIds) {
          props.item.incrementalIds.forEach(id => {
            handleIncrementalMessage(incrementalMessageList.value[id]);
          });
        }
      } catch (error) {
        info.value = {};
        console.log(error);
      }
    });
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_popover = _resolveComponent("el-popover");
      return _openBlock(), _createBlock(FoldBox, {
        ref_key: "FoldBoxRef",
        ref: FoldBoxRef,
        id: props.item.id,
        status: info.value.executeStatus || 1,
        showDownIcon: Boolean(showContent.value),
        onRestart: handleRestart
      }, {
        title: _withCtx(() => [_createTextVNode(_toDisplayString(showTitle.value), 1)]),
        default: _withCtx(() => [showContent.value ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
          ref_key: "contentRef",
          ref: contentRef,
          class: "bg-white rounded-lg"
        }, [_createVNode(ContentBlock, {
          content: info.value.content || '',
          cusSty: !__props.item.openAnimate ? 1 : undefined,
          isAnimate: __props.item.openAnimate,
          isMd: true,
          height: "400px",
          animateTime: 0,
          onAnimateEnd: handleAnimateEnd
        }, null, 8, ["content", "cusSty", "isAnimate"])], 512), showLinks.value.length ? (_openBlock(), _createBlock(SourceBlock, {
          key: 0,
          class: "mt-4",
          links: showLinks.value
        }, null, 8, ["links"])) : _createCommentVNode("", true)])) : _createCommentVNode("", true), keywordList.value.length && animateEnd.value ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_cache[19] || (_cache[19] = _createElementVNode("div", {
          class: "text-sm font-semibold leading-5 mb-4"
        }, "常搜关键词", -1)), (_openBlock(), _createBlock(KeyWord, {
          key: props.item.id,
          keywordList: keywordList.value,
          "onUpdate:keywordList": _cache[0] || (_cache[0] = $event => keywordList.value = $event),
          keyWordArr: keyWordArr.value,
          "onUpdate:keyWordArr": _cache[1] || (_cache[1] = $event => keyWordArr.value = $event),
          disabled: disabled.value,
          onChange: handleChangeKeyword
        }, null, 8, ["keywordList", "keyWordArr", "disabled"])), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createVNode(_component_el_popover, {
          width: "295px",
          disabled: !_unref(appStore).getRightsByIds([605, 628]),
          "popper-class": "p-none",
          placement: "top",
          "show-arrow": false
        }, {
          reference: _withCtx(() => [_createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[5] || (_cache[5] = $event => handleCreateInfo(0))
          }, {
            default: _withCtx(() => [...(_cache[16] || (_cache[16] = [_createTextVNode(" 快捷生成企业知识库 ", -1)]))]),
            _: 1
          })]),
          default: _withCtx(() => [_createElementVNode("div", _hoisted_5, [_cache[15] || (_cache[15] = _createElementVNode("div", {
            class: "popover-title text-sm text-[#1D2129] text-center mb-1"
          }, " 选择生成的企业资料库类型 ", -1)), _createElementVNode("div", {
            class: "type-item cursor-pointer",
            onClick: _cache[2] || (_cache[2] = $event => handleCreateInfo(1))
          }, [_cache[8] || (_cache[8] = _createElementVNode("div", null, "生成内贸/海外企业知识库", -1)), _createElementVNode("div", _hoisted_6, [_cache[6] || (_cache[6] = _createElementVNode("img", {
            src: _imports_0,
            alt: "",
            class: "w-4 h-4 mr-[2px]"
          }, null, -1)), _cache[7] || (_cache[7] = _createTextVNode(" 消耗 ", -1)), _createElementVNode("span", null, _toDisplayString(getRightNum(1)) + "点/次", 1)])]), _createElementVNode("div", {
            class: "type-item cursor-pointer",
            onClick: _cache[3] || (_cache[3] = $event => handleCreateInfo(2))
          }, [_cache[11] || (_cache[11] = _createElementVNode("div", null, "生成内贸企业知识库", -1)), _createElementVNode("div", _hoisted_7, [_cache[9] || (_cache[9] = _createElementVNode("img", {
            src: _imports_0,
            alt: "",
            class: "w-4 h-4 mr-[2px]"
          }, null, -1)), _cache[10] || (_cache[10] = _createTextVNode(" 消耗 ", -1)), _createElementVNode("span", null, _toDisplayString(getRightNum(2)) + "点/次", 1)])]), _createElementVNode("div", {
            class: "type-item cursor-pointer",
            onClick: _cache[4] || (_cache[4] = $event => handleCreateInfo(3))
          }, [_cache[14] || (_cache[14] = _createElementVNode("div", null, "生成海外企业知识库", -1)), _createElementVNode("div", _hoisted_8, [_cache[12] || (_cache[12] = _createElementVNode("img", {
            src: _imports_0,
            alt: "",
            class: "w-4 h-4 mr-[2px]"
          }, null, -1)), _cache[13] || (_cache[13] = _createTextVNode(" 消耗 ", -1)), _createElementVNode("span", null, _toDisplayString(getRightNum(3)) + "点/次", 1)])])])]),
          _: 1
        }, 8, ["disabled"]), _createVNode(_component_el_button, {
          class: "view-btn ml-3",
          onClick: handleEditView
        }, {
          default: _withCtx(() => [...(_cache[17] || (_cache[17] = [_createTextVNode("全屏查看/预览", -1)]))]),
          _: 1
        }), !disabled.value ? (_openBlock(), _createBlock(_component_el_button, {
          key: 0,
          type: "primary",
          class: "submit-btn",
          disabled: !keyWordArr.value.length,
          loading: loading.value,
          onClick: createTask
        }, {
          default: _withCtx(() => [...(_cache[18] || (_cache[18] = [_createTextVNode(" 生成网站分析报告 ", -1)]))]),
          _: 1
        }, 8, ["disabled", "loading"])) : _createCommentVNode("", true)])])])) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["id", "status", "showDownIcon"]);
    };
  }
});